// Base site URL - should be set in environment variables
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://ubr.org.ua";

export const SITE_NAME = "Universal Business Resource";

export const DEFAULT_DESCRIPTION =
  "Професійні послуги з бухгалтерського обліку, оподаткування та юридичного супроводу для бізнесу в Україні";

export const DEFAULT_KEYWORDS =
  "бухгалтерський облік, оподаткування, юридичний супровід, ФОП, юридична особа, Україна";
